/* Initialize JS youtube player API across es6 modules that accepts a DOM element with options to override,
create the player and store it on the elment itself (in a WeakMap). It will be the componets responsinblity
to use the player instance and handle component specific logic and events. Although some common
performance related functionalities can be implemented here e.g stop video when not in view etc */

import YoutubePlayer from 'youtube-player';
import { DomWeakMapUtil } from './dom';

export default class YoutubePlayerWrapper {
    constructor(el, options) {
        this.el = el;
        this.parentElement = el.parentElement;
        this.isPortrait = window.matchMedia('(orientation: portrait)', '(max-width: 480px)').matches;
        this.videoId = this.el.dataset.videoMobileId && this.isPortrait ? this.el.dataset.videoMobileId : this.el.dataset.videoId;
        this.defaultOptions = {
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                controls: 1,
            },
        };
        this.bgVideoOptions = {
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                controls: 0,
                playsinline: 1,
                autoplay: 1,
                modestbranding: 1,
                mute: 1,
                rel: 0,
                loop: 1,
                playlist: this.videoId,
            },
        };
        this.isBgVideo = options && options.isBgVideo ? options.isBgVideo : false;
        this.playerOptions = null;
        this.init();
        this.bindEvents();
    }

    static classes = {
        ytPlayerClass: 'js-yt-player',
    };

    static getUniqueYTPlayerID(videoId) {
        return (window.crypto.randomUUID ? window.crypto.randomUUID() : `${videoId}-${window.crypto.getRandomValues(new Uint32Array(1))[0]}`);
    }

    createYTPlayerInstance() {
        const self = this;
        const mobileVideo = self.el.dataset.videoMobileId;
        if (mobileVideo)self.el.closest('.xl-tile-lite-media-wrapper')?.classList.add('mobile_video_wrapper');
        return YoutubePlayer(self.el, self.playerOptions);
    }

    setPlayerOptions() {
        const self = this;
        const options = self.isBgVideo ? self.bgVideoOptions : self.defaultOptions;
        self.playerOptions = { videoId: self.videoId, ...options, ...options.overRides };
    }

    getPlayerInstance() {
        const self = this;
        return DomWeakMapUtil(self.el, 'youtubePlayer');
    }

    setInstersectionObserver() {
        const self = this;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0,
        };

        const observer = new IntersectionObserver(self.updatePlayerState.bind(self), options);
        observer.observe(self.parentElement);
    }

    updatePlayerState(entries) {
        const self = this;
        let videoID = self.videoId;
        let duration = '';
        const player = self.getPlayerInstance();

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                player.playVideo();
            } else {
                player.pauseVideo();
            }
        });

        player.on('stateChange', (event) => {
            const YTP = event.target;
            videoID = YTP.playerInfo.videoData.video_id;
            duration = YTP.playerInfo.duration;
            const currentVdo = localStorage.getItem('currentVdo');
            const localVdoData = JSON.parse(currentVdo);

            if (localVdoData?.videoID !== videoID) {
                const obj = {
                    videoId: videoID,
                    vdoDuration: duration,
                };
                localStorage.setItem('currentVdo', JSON.stringify(obj));
            }
            if (event.data === -1 || event.data === 3) {
                duration = localVdoData?.vdoDuration;
            }

            if (duration) {
                clearTimeout(YTP.setLoop);
                YTP.setLoop = setTimeout(() => {
                    YTP.seekTo(0);
                }, (duration <= 11 ? duration - 0.5 : duration - 1) * 1000);
            }
        });
    }

    bindEvents() {
        const self = this;
        if (self.isBgVideo) {
            self.setInstersectionObserver();
        }
    }

    init() {
        const self = this;
        self.el.classList.add(YoutubePlayerWrapper.classes.ytPlayerClass);
        self.el.setAttribute('id', YoutubePlayerWrapper.getUniqueYTPlayerID(self.el.dataset.videoId));
        self.setPlayerOptions();
        DomWeakMapUtil(self.el, 'youtubePlayer', self.createYTPlayerInstance());
    }
}
